import jsBridge from './utils/bridge.mjs';
import { API_NAVIGATE_TO, API_REDIRECT_TO, API_NAVIGATE_BACK, API_LAUNCH_TRUSTED_WEB_BROWSER, API_NAVIGATE_TO_CART } from './utils/constant.mjs';
/**
 * 跳转新页面，用于解决跨域 iframe 无法自动跳转的问题
 * @param params
 * @returns
 */
export function navigateTo(params) {
    return jsBridge.callPromise({
        minVersion: '1.0.3',
        noResponse: true
    }, API_NAVIGATE_TO, params);
}
/**
 * 重定向到新页面, 用于解决跨域 iframe 无法自动跳转的问题，不支持 app
 * @param params
 * @returns
 */
export function redirectTo(params) {
    return jsBridge.callPromise({
        noResponse: true
    }, API_REDIRECT_TO, params);
}
/**
 * 返回
 * @param params
 * @returns
 */
export function navigateBack(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.0.3',
        noResponse: true
    }, API_NAVIGATE_BACK, params);
}
/**
 * 浏览器返回，当返回到第一层时调用 navigateBack 关闭当前容器
 */
export function historyBack() {
    const { href } = window.location;
    window.history.back();
    setTimeout(() => {
        if (href === window.location.href) {
            navigateBack();
        }
    }, 50);
}
/**
 * 打开应用内安全浏览器，目前是为了 paypal passkey login
 */
export function launchTrustedWebBrowser(params) {
    return jsBridge.callPromise({
        minVersion: '1.0.8',
        androidMinVersion: '999.0.0',
        timeout: 0
    }, API_LAUNCH_TRUSTED_WEB_BROWSER, params);
}
/**
 * 跳转购物车页面
 * @param params
 * @returns
 */
export function navigateToCart(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.1.3',
        noResponse: true
    }, API_NAVIGATE_TO_CART, params);
}
